import { useQuery } from '@tanstack/react-query';
import { clientFetch } from '~/lib/.client/fetch';
import { projectStore } from '~/lib/stores/project';
import { invariant } from '~/utils/invariant';

const getBuckets = async (projectId?: string) => {
  invariant(projectId);
  const response = await clientFetch(`/api/supabase/projects/${projectId}/buckets`);

  const result = await response.json<{ message: string } | any[]>();

  if ('message' in result) {
    throw new Error(result.message);
  }

  return result;
};

export const useGetBuckets = () => {
  const projectId = projectStore.projectId.get();
  return useQuery({
    queryKey: ['buckets', projectId],
    queryFn: () => getBuckets(projectId),
    enabled: !!projectId,
    retry: false,
  });
};
